document.addEventListener('DOMContentLoaded', function() {
            // Handle variant selection for each product section
        document.querySelectorAll('.variant-option[data-available="true"]').forEach(option => {
            option.addEventListener('click', function() {
                // Find the product section (new-product-hero, coffee-hero, or bg-lightpurple)
                let productContainer = this.closest('.new-product-hero');
                let isCoffeeHero = false;
                let isPurpleCoffeeHero = false; // legacy purple hero using CSS .selected
                let isNewHero = false;
                let isBrainpowerHero = false;
                let isStressHero = false;
                let isSommeilHero = false;
                let isEnergyHero = false;
                let isImmuHero = false;
                let isMuscuHero = false;
                let isRelaxHero = false;
                let isLimitlessHero = false;
                let isDecouverteHero = false;
                
                if (productContainer) {
                    // Check hero type using data attribute for more reliable detection
                    const heroType = productContainer.getAttribute('data-hero-type');
                    
                    if (heroType === 'coffee') {
                        isCoffeeHero = true;
                    } else if (heroType === 'entrepreneur' || productContainer.querySelector('#focus-why-container')) {
                        isNewHero = true;
                    } else if (heroType === 'stress' || productContainer.querySelector('#stress-why-container')) {
                        isStressHero = true;
                    } else if (heroType === 'sommeil' || productContainer.querySelector('#sommeil-why-container')) {
                        isSommeilHero = true;
                    } else if (heroType === 'energy' || productContainer.querySelector('#energy-why-container')) {
                        isEnergyHero = true;
                    } else if (heroType === 'immu' || productContainer.querySelector('#immu-why-container')) {
                        isImmuHero = true;
                    } else if (heroType === 'muscu' || productContainer.querySelector('#muscu-why-container')) {
                        isMuscuHero = true;
                    } else if (heroType === 'relax' || productContainer.querySelector('#relax-why-container')) {
                        isRelaxHero = true;
                    } else if (heroType === 'limitless' || productContainer.querySelector('#limitless-why-container')) {
                        isLimitlessHero = true;
                    } else if (heroType === 'decouverte' || productContainer.querySelector('#decouverte-why-container')) {
                        isDecouverteHero = true;
                    } else {
                        isNewHero = true;
                    }
                } else {
                    productContainer = this.closest('.brainpower-hero');
                    if (productContainer) {
                        isBrainpowerHero = true;
                    } else {
                        productContainer = this.closest('.coffee-hero');
                        if (productContainer) {
                        // Only treat as brown coffee if data-hero-type === 'coffee'.
                        const heroType = productContainer.getAttribute('data-hero-type');
                        if (heroType === 'coffee') {
                            isCoffeeHero = true;
                        } else {
                            isPurpleCoffeeHero = true;
                        }
                    } else {
                        productContainer = this.closest('div.bg-lightpurple');
                        }
                    }
                }
            
            if (!productContainer) return;

            // Get all variants in this product (exclude subscription widget variants)
            const variants = productContainer.querySelectorAll('.variant-option[data-available="true"]:not([data-widget-type])');

            if (isPurpleCoffeeHero) {
                // PURPLE COFFEE HERO (legacy) - rely on CSS .selected like in template
                variants.forEach(variant => {
                    variant.classList.remove('selected');
                    // clear any inline colors previously applied
                    variant.style.borderColor = '';
                    variant.style.background = '';
                    variant.style.color = '';
                });
                this.classList.add('selected');
            } else if (isBrainpowerHero) {
                // BRAINPOWER HERO STYLING - Use .selected class logic
                variants.forEach(variant => {
                    variant.classList.remove('selected');
                });
                this.classList.add('selected');
            } else if (isEnergyHero) {
                // ENERGY HERO STYLING - Apply red colors
                console.log('Applying ENERGY styling with red colors');
                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#E74C3C';
                    variant.style.background = 'rgba(217, 48, 37, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#D93025';

            } else if (isSommeilHero) {
                // SOMMEIL HERO STYLING - Apply purple colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#694C9E';
                    variant.style.background = '#9D87C5';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#694C9E';

            } else if (isStressHero) {
                // STRESS HERO STYLING - Apply orange colors (original)

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#f3a578';
                    variant.style.background = 'rgba(241, 120, 51, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#F17934';

            } else if (isImmuHero) {
                // IMMU HERO STYLING - Apply purple colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#C086CA';
                    variant.style.background = 'rgba(124, 47, 138, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#7C2F8A';

            } else if (isMuscuHero) {
                // MUSCU HERO STYLING - Apply pink colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#E281AC';
                    variant.style.background = 'rgba(189, 61, 117, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#BD3D75';

            } else if (isRelaxHero) {
                // RELAX HERO STYLING - Apply purple colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#CAB3ED';
                    variant.style.background = 'rgba(131, 94, 206, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#835ECE';

            } else if (isLimitlessHero) {
                // LIMITLESS HERO STYLING - Apply purple colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#B18CDB';
                    variant.style.background = 'rgba(116, 54, 185, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#7436B9';

            } else if (isDecouverteHero) {
                // DÉCOUVERTE HERO STYLING - Apply pink colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '#F8B1EC';
                    variant.style.background = 'rgba(220, 96, 199, 0.5)';
                });

                // Style the clicked variant
                this.style.borderColor = '#f9f785';
                this.style.background = '#DC60C7';

            } else if (isNewHero) {
                // NEW HERO STYLING - Apply custom colors

                variants.forEach(variant => {
                    // Reset to default state
                    variant.style.borderColor = '';
                    variant.style.background = 'rgba(36, 88, 162, 0.42)';
                });

                // Style the clicked variant
                this.style.borderColor = getComputedStyle(document.documentElement).getPropertyValue('--accent-color') || '#f9f785';
                this.style.background = '#2458A2';
            } else if (isCoffeeHero) {
                // COFFEE HERO STYLING - Apply coffee color scheme
                variants.forEach(variant => {
                    variant.style.borderColor = '#ECE6DE';
                    variant.style.background = 'rgba(236,230,222,0.5)';
                    variant.style.color = '#2E2720';
                });
                this.style.borderColor = '#ECE6DE';
                this.style.background = '#2E2720';
                this.style.color = '#ECE6DE';
            } else {
                // PRODUCT HERO STYLING - Apply CSS classes
                variants.forEach(variant => {
                    // Reset all variants to default state
                    variant.classList.remove("bg-mediumpurple", "text-white", "border-yellow");
                    variant.classList.add("bg-white", "text-darkpurple", "border-darkpurple");
                });

                // Set the clicked variant to active state
                this.classList.remove("bg-white", "text-darkpurple", "border-darkpurple");
                this.classList.add("bg-mediumpurple", "text-white", "border-yellow");
            }

            // Update the hidden input
            const variantId = this.dataset.variantId;
            const variantPrice = this.dataset.price;
            const variantDuration = this.dataset.duration;
            
            // Find the closest input[name="id"] in the same section
            let input = productContainer.querySelector('input[name="id"]');
            if (!input) {
                // fallback: try to find in parent forms
                input = this.closest('form')?.querySelector('input[name="id"]');
            }
            if (input) input.value = variantId;

            // Update duration text if it exists
            const durationText = productContainer.querySelector('.duration-text');
            if (durationText && variantDuration) {
                const template = durationText.getAttribute('data-template');
                if (template) {
                    durationText.textContent = template.replace('%days%', variantDuration);
                }
            }

            // Dispatch the change event
            document.dispatchEvent(new CustomEvent('variant:changed', {
                detail: {
                    variantId: variantId,
                    price: parseInt(variantPrice)
                }
            }));
        });
    });

    // Select first available variant for each product (coffee-hero handles its own initialization)
    document.querySelectorAll('.new-product-hero, .entrepreneur-hero, div.bg-lightpurple').forEach(container => {
        const firstVariant = container.querySelector('.variant-option[data-available="true"]');
        if (firstVariant) {
            firstVariant.click();
        }
    });
    
    // Coffee hero initialization is handled in coffee-hero.liquid itself
});
